module.exports = __webpack_public_path__ + "static/media/logo-internal.22199e93.png";